import RibbonFormatState from '../store/schema/RibbonFormatState';
import toggleFormatPainter from '../actions/toggleFormatPainter';
import {
    getFormatState,
    setBackgroundColor,
    setFontName,
    setFontSize,
    setTextColor,
    toggleBold,
    toggleItalic,
    toggleUnderline,
} from 'roosterjs-editor-api';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { ChangeSource } from 'roosterjs-editor-types';

export default function formatPainterFinish(
    editorViewState: EditorViewState,
    formatState: RibbonFormatState
) {
    lazyOperateContent.import().then(operateContent => {
        operateContent(editorViewState, (editor, range) => {
            let cachedFormat = formatState.formatPainterFormat;

            if (range && cachedFormat) {
                // If the current range is collapsed, select the node at cursor
                if (range.collapsed) {
                    range.selectNode(editor.getElementAtCursor());
                }

                const currentFormat = getFormatState(editor);
                const textColor =
                    cachedFormat.textColors ||
                    currentFormat.textColors ||
                    cachedFormat.textColor ||
                    currentFormat.textColor;
                const backgroundColor =
                    cachedFormat.backgroundColors ||
                    currentFormat.backgroundColor ||
                    cachedFormat.backgroundColors ||
                    currentFormat.backgroundColor;

                editor.addUndoSnapshot(() => {
                    setFontName(editor, cachedFormat.fontName || currentFormat.fontName);
                    setFontSize(editor, cachedFormat.fontSize || currentFormat.fontSize);
                    setTextColor(editor, textColor);
                    setBackgroundColor(editor, backgroundColor);
                    toggleBold(editor);
                    toggleItalic(editor);
                    toggleUnderline(editor);
                    if (cachedFormat.isBold == currentFormat.isBold) {
                        toggleBold(editor);
                    }
                    if (cachedFormat.isItalic == currentFormat.isItalic) {
                        toggleItalic(editor);
                    }
                    if (cachedFormat.isUnderline == currentFormat.isUnderline) {
                        toggleUnderline(editor);
                    }
                }, ChangeSource.Format);
            }

            return range;
        });

        toggleFormatPainter(editorViewState, formatState, false);
    });
}
